import { Table, Tag, Tooltip, Progress } from "antd";
import DetalleTable from "./DetalleTable";
import { useState } from "react";
import { getDetalleProducto } from "../../../../services/financiero/productosEntregasService";

// 🔥 Helpers de formato
const formatNumber = (value) => {
  if (!value) return "0";
  return Number(value).toLocaleString("es-CO", {
    maximumFractionDigits: 0
  });
};

const formatCurrency = (value) => {
  if (!value) return "$0";
  return `$${Number(value).toLocaleString("es-CO", {
    maximumFractionDigits: 0
  })}`;
};

export default function ProductosTable({ data }) {
  const [detalles, setDetalles] = useState({});

  const handleExpand = async (expanded, record) => {
    if (expanded && !detalles[record.producto_id]) {
      const res = await getDetalleProducto(record.producto_id);
      setDetalles(prev => ({ ...prev, [record.producto_id]: res }));
    }
  };

  const columns = [
    {
      title: "PO",
      dataIndex: "Numero_PO",
      width: 100
    },
    {
      title: "Producto",
      dataIndex: "nombre_producto",
      width: 300,
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              maxWidth: 280,
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.2em"
            }}
          >
            {text}
          </div>
        </Tooltip>
      )
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      width: 150
    },
    {
      title: "Proyecto",
      dataIndex: "codigo_proyecto",
      width: 120
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad_total",
      width: 120,
      render: (v) => formatNumber(v)
    },
    {
      title: "Valor Unitario",
      width: 150,
      render: (_, r) => formatCurrency(r.valor_unitario_COP)
    },
    {
      title: "Total",
      width: 150,
      render: (_, r) => (
        <span style={{ fontWeight: 600 }}>
          {formatCurrency(r.valor_total)}
        </span>
      )
    },
    {
      title: "% Entrega",
      width: 180,
      render: (_, r) => (
        <Progress
          percent={Number(r.porcentaje_entrega)}
          size="small"
          status={
            Number(r.porcentaje_entrega) === 100
              ? "success"
              : "active"
          }
        />
      )
    },
    {
      title: "Estado",
      dataIndex: "estado",
      width: 140,
      render: (v) =>
        v === "ENTREGADO"
          ? <Tag color="green">Entregado</Tag>
          : <Tag color="orange">Disponible</Tag>
    }
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey="producto_id"
      scroll={{ x: 1100 }} // 🔥 controla ancho horizontal
      expandable={{
        expandedRowRender: (record) => (
          <DetalleTable data={detalles[record.producto_id] || []} />
        ),
        onExpand: handleExpand
      }}
    />
  );
}